import './BlogPageSearch.scss';
import React from 'react';
import { cn } from '../../../common/utils/bem';
import { Button } from '@dataartdev/uikit/Button';
import { TextField } from '@dataartdev/uikit/TextField';
import { IconArrowRight } from '@dataartdev/uikit/IconArrowRight';

export const cnBlogPageSearch = cn('BlogPageSearch');

interface Props {
  placeholder?: string;
  nameSelected?: string;
  setNameSelected: (value: string) => void;
  nameChange: (value: string) => void;
}

export const BlogPageSearch: React.FC<Props> = ({
  placeholder = 'Search',
  nameSelected = '',
  setNameSelected,
  nameChange,
}) => {
  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    nameChange(nameSelected);
  };

  return (
    <form className={cnBlogPageSearch()} onSubmit={handleSubmit}>
      <TextField
        name="name"
        view="outline"
        width="full"
        autoComplete="off"
        autoFocus
        placeholder={placeholder}
        value={nameSelected}
        onChange={(e: any) => setNameSelected(e.value)}
      />
      <Button
        iconRight={IconArrowRight}
        type="submit"
        disabled={!nameSelected}
      />
    </form>
  );
};
